module.exports = __webpack_public_path__ + "static/media/CDC-Mentions2-FR.ac75fb65.jpg";